import Vue from 'vue'
export default new Vue()


// WEBPACK FOOTER //
// ./src/utils/eventBus.js